export default "__VITE_ASSET__NWa0agXP__"